import React, { useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Transfer from "../../../../components/shared/Transfer";
import { useTextResources } from '../../../../language';

const ExcludeCustomerGroupsTransfer = ({
    promotionExcludedCustomerGroups,
    promotionCustomerGroups,
    onChange,
}) => {
    const text = useTextResources();

    const [targetKeys, setTargetKeys] = useState([]);

    useEffect(() => {
        setTargetKeys(promotionExcludedCustomerGroups);
    }, [promotionExcludedCustomerGroups])

    useEffect(() => {
        onChange(targetKeys)
    }, [targetKeys, onChange])

    const searchSelector = useCallback((customerGroup, searchTerm) => {
        return customerGroup.Name?.toLowerCase().includes(searchTerm?.toLowerCase());
    }, []);

    const handleCustomerGroupsChange = useCallback((keys) => {
        setTargetKeys(keys);
    }, []);

    const keySelector = useCallback((customerGroup) => customerGroup.Id, []);
    const itemRender = useCallback((customerGroup) => {
        return `${customerGroup.Name} - ${customerGroup.Rates?.join(', ')}`;
    }, []);

    return (
        <Transfer
            items={promotionCustomerGroups}
            itemKeySelector={keySelector}
            itemRender={itemRender}
            targetKeys={targetKeys}
            hasSearch
            targetListLabel={text("ExcludedCustomerGroups")}
            sourceListLabel={text("IncludedCustomerGroupsForBaseRates")}
            searchSelector={searchSelector}
            hasSelectAll
            onTargetKeysChange={handleCustomerGroupsChange}
            isSourceShownOnRightSide
        />
    );
};

ExcludeCustomerGroupsTransfer.propTypes = {
    onChange: PropTypes.func.isRequired,
    promotionExcludedCustomerGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
    promotionCustomerGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ExcludeCustomerGroupsTransfer;